<router-outlet></router-outlet>
<app-loader [loader$]="loader$"></app-loader>

